module.exports = __webpack_public_path__ + "static/media/picto-green-slow.c60923dc.png";